import { TableTemplate } from 'types/tableTemplate';

export const boardProductsTableTemplate: TableTemplate[] = [
  {
    id: 'actions',
    description: 'AÇÕES',
    originalId: 'actions',
    width: 50,
  },
  {
    id: 'board_number',
    description: 'MESA',
    originalId: 'board_number',
    width: 50,
  },
  {
    id: 'id',
    description: 'PEDIDO',
    originalId: 'id',
    width: 70,
  },
  {
    id: 'name',
    description: 'PRODUTO',
    originalId: 'name',
    width: 300,
  },
  {
    id: 'amount',
    description: 'QTD',
    originalId: 'amount',
    width: 50,
  },
  {
    id: 'formattedFinalPrice',
    description: 'TOTAL',
    originalId: 'final_price',
    width: 100,
  },
  {
    id: 'formattedStatus',
    description: 'STATUS',
    originalId: 'status',
    width: 145,
  },
  {
    id: 'admin_user_name',
    description: 'USUÁRIO',
    originalId: 'admin_user_name',
    width: 200,
  },
  {
    id: 'formattedCreatedAt',
    description: 'DATA',
    originalId: 'created_at',
    width: 150,
  },
];
